<div class="skill-header">SKILLS</div>
<div class="skill-container" fxLayout="row wrap">
  <app-fill-chip *ngFor="let skill of skill$ | async" [percentFilled]="skill.proficiency" [description]="skill.skillDescription" class="chip"></app-fill-chip>
</div>
